export class SelectableCategory {
    id: number;
    name: string;
    description: string;
    children: Array<SelectableCategory>;
    isSelected: boolean;
    nodeType: string;
    keywords: string;
    isExpanded: boolean;
    show = true;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/categories/category.models.ts